<div class="preview_wrapper">
  <p class="title">Add Purchase Order
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <!-- Show "Vendor Name" when type is vendor, otherwise "Job Name" -->
        <p class="heading">{{addPurchaseOrderObject?.selectedType === 'vendor' ? 'Vendor Name' : 'Job Name'}}</p>

        <!-- Vendor Type -->
        @if (addPurchaseOrderObject?.selectedType === 'vendor') {
          <p class="value">
            {{addPurchaseOrderObject?.vendorName}}
          </p>
        }

        <!-- Regular Type -->
        @if (addPurchaseOrderObject?.selectedType === 'regular') {
          <p class="value">
            {{addPurchaseOrderObject?.job_name}}
          </p>
        }

        <!-- Bulk Type -->
        @if (addPurchaseOrderObject?.selectedType === 'bulk') {
          <p class="value">
            @for (item of addPurchaseOrderObject.jobDetail; track item) {
              <span>
                {{item?.name}}
              </span>
            }
          </p>
        }
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Purchase Order Type</p>
        <p class="value">
          {{addPurchaseOrderObject?.selectedType === 'bulk' ? 'Bulk' : (addPurchaseOrderObject?.selectedType === 'vendor' ? 'Vendor' : 'Regular')}}
        </p>
      </div>
    </div>
  </div>
</div>